/* eslint-disable */
import { SiglasUnidadeMedida } from "@/utils/helpers/enums/SiglaUnidadeMedida";
import { normalizeString } from "@/utils/normalizeString";

const siglaUnidadeMedidaFilter = {
  install(Vue) {
    Vue.filter('siglaUnidadeMedida', (data) => {
      const stringNormalizada = normalizeString(data);
      if(stringNormalizada !== undefined)
        return SiglasUnidadeMedida[stringNormalizada];
      return '';
    });
  },
};

export default siglaUnidadeMedidaFilter;
